import { Stack } from "@mantine/core"
import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  OnChangeFn,
  PaginationState,
  useReactTable,
} from "@tanstack/react-table"
import { useEffect, useState } from "react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { Table } from "~/components/table/Table.tsx"
import { useColumns } from "~/pages/Brand/Suppliers/List/SupplierProductionSites/columns.tsx"

interface Props {
  productionSitesData: LibraryResponses.SupplierProductionSitesResponse
  setPagination: OnChangeFn<PaginationState>
  pagination: PaginationState
  searchProductionSites: string
  setSearchProductionSites: (value: string) => void
}

const PAGE_SIZE = 20

export const SupplierProductionSites = ({
  productionSitesData,
  setPagination,
  pagination,
  searchProductionSites,
  setSearchProductionSites,
}: Props) => {
  const { count, productionSites, prodSiteFieldHeaders } = productionSitesData
  const [pageCount, setPageCount] = useState(1)

  useEffect(() => {
    setPageCount(Math.ceil(count / PAGE_SIZE))
  }, [count])

  const columns = useColumns(prodSiteFieldHeaders)
  const table = useReactTable({
    data: productionSites,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: PAGE_SIZE,
      },
    },
    state: {
      globalFilter: searchProductionSites,
      pagination,
    },
    pageCount,
    onGlobalFilterChange: setSearchProductionSites,
    manualPagination: true,
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  })

  return (
    <Stack>
      <Table
        table={table}
        pageIndex={pagination.pageIndex}
        pagination={true}
        manualPaginationCount={count}
      />
    </Stack>
  )
}
